/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Project_Import_CompleteInputs */



/**
* | output |
* | --- |
* | "Importing team project complete" |
*
* @param {Team_Project_Import_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_project_import_complete = /** @type {((inputs?: Team_Project_Import_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Project_Import_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation du projet d’équipe terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt des Importteams abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione del progetto di gruppo completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Проект команды по импорту завершен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación del proyecto del equipo completada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入团队项目完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("チームプロジェクトのインポートが完了しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टीम प्रोजेक्ट का आयात पूरा हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto de equipe de importação concluído")
	return /** @type {LocalizedString} */ ("Importing team project complete")
});